/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
// Forza visibilità link recesso su mobile
document.addEventListener('DOMContentLoaded', function() {
  var recessoLink = document.querySelector('a[href*="diritto-di-recesso"]');
  if (recessoLink) {
    var wrapper = recessoLink.closest('[data-collapsible-container-mobile]');
    if (wrapper) {
      wrapper.style.setProperty('height', 'auto', 'important');
      wrapper.style.setProperty('overflow', 'visible', 'important');
      wrapper.style.setProperty('visibility', 'visible', 'important');
      var content = recessoLink.closest('[data-collapsible-content]');
      if (content) {
        content.style.setProperty('display', 'block', 'important');
      }
    }
  }
});

